import { AccountInfo } from "@azure/msal-browser";

export const CHAT_ENABLED_CLIENTS: string[] | null = null;

export const CHAT_ENABLED_EMAIL_DOMAINS: string[] | null = ["heroes"];

export const isChatEnabledForClient = (clientName?: string) => {
	if (!CHAT_ENABLED_CLIENTS) return true;
	return CHAT_ENABLED_CLIENTS.includes(clientName?.toLowerCase() ?? "");
};

export const isChatEnabledForAccount = (account?: AccountInfo | null) => {
	if (!CHAT_ENABLED_EMAIL_DOMAINS) return true;
	const claims = account?.idTokenClaims as { emails?: string[] } | undefined;
	const email = (account?.username || claims?.emails?.[0] || "").toLowerCase();
	const domain = email.split("@")[1] ?? "";
	return CHAT_ENABLED_EMAIL_DOMAINS.some((allowed) => domain.includes(allowed));
};
